import type { QueryClient } from '@tanstack/react-query';
import type { MySquaresPick } from './getMyPicks';
import type { SquaresContestResponse } from './getSquares';

type MyPicksCache = { squares_contests: MySquaresPick[] };

export const MY_PICKS_QUERY_KEY = ['squares', 'my-picks'] as const;

export function upsertContestInMyPicksCache(
  queryClient: QueryClient,
  contest: SquaresContestResponse,
  selectedSquareId?: number
) {
  const contestId = contest.squares_contest_id || contest.question_id;
  if (!contestId) return;

  const squareNumber = selectedSquareId != null ? selectedSquareId + 1 : undefined;

  queryClient.setQueryData<MyPicksCache>(MY_PICKS_QUERY_KEY, old => {
    const existing = old?.squares_contests ?? [];
    const without = existing.filter(
      pick => String(pick.question_id || pick.squares_contest_id) !== String(contestId)
    );

    const entry: MySquaresPick = {
      ...contest,
      squares_contest_id: contest.squares_contest_id || String(contestId),
      user_selected_square: squareNumber,
      user_selected_row_index:
        selectedSquareId != null ? Math.floor(selectedSquareId / 10) : undefined,
      user_selected_col_index: selectedSquareId != null ? selectedSquareId % 10 : undefined,
    };

    return { squares_contests: [entry, ...without] };
  });
}

export async function refreshMyPicksCache(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: MY_PICKS_QUERY_KEY });
  await queryClient.refetchQueries({ queryKey: MY_PICKS_QUERY_KEY });
}
